import { def } from "./config";

export const configurations = {
  hotelSuppliers: ["StayX2", "StayX3"],
  // hotelSuppliers: ["StayX2"],
  hotelSupplierExceptions: ["StayX3"],
  insuranceRecentSearchKey: "insuranceRecentSearch",
  insuranceNoMedicalSuppliers: ["Airhelp Plus"],
  insuranceKeyword: "Protection",
  stayKeyword: "Stays",
  tourKeyword: "Tour",
  services: {
    flight: {
      label: "Flight",
      code: "flight",
    },
    stay: {
      label: "Stay",
      code: "stay",
    },
    tour: {
      label: "Tour",
      code: "tour",
    },
    insurance: {
      label: "Protection",
      code: "insurance",
    },
    package: {
      value: "package",
      alias: "Package",
    },
    esim: {
      value: "esim",
      alias: "eSIM",
    },
  },
  milesPoints: {
    base_url: `${def.milesPointApi}/v1`,
    tabs: {
      mission: { code: "mission", label: "Missions" },
      badge: { code: "badge", label: "Badges" },
      reward: { code: "reward", label: "Rewards" },
      leaderboard: { code: "leaderboard", label: "Leaderboard" },
      log: { code: "log", label: "Points Log" },
    },
  },
};
